import { Switch } from '@mui/material';
import styled from 'styled-components';

export const StyledSwitch = styled(Switch)`
  && {
    width: 2.25rem;
    height: 1.25rem;
    padding: 0;
    position: relative;
    border-radius: 0.75rem;
    margin: -1px !important;

    &.MuiSwitch-switchBase {
      padding: 0;
      margin: ${({ theme }) => theme.spacing(2)};
    }

    & .Mui-checked {
      transform: translateX(1rem);

      & + .MuiSwitch-track {
        background-color: ${({ theme }) => theme.palette.primary.main};
      }
    }

    & .MuiSwitch-track {
      opacity: 1 !important;
      background-color: ${({ theme }) => theme.palette.primary.light};
    }

    & .MuiSwitch-thumb {
      width: 1rem;
      height: 1rem;
      border-radius: 50%;
      position: absolute;
      top: 0.125rem;
      left: 0.125rem;
      color: ${({ theme }) => theme.palette.primary.contrastText};
      box-shadow: none;
      filter: drop-shadow(
          0px 3px 6px ${({ theme }) => theme.palette.common.black}0D
        )
        drop-shadow(0px 2px 4px ${({ theme }) => theme.palette.common.black}0D)
        drop-shadow(0px 1px 2px ${({ theme }) => theme.palette.common.black}0D)
        drop-shadow(0px 1px 0px ${({ theme }) => theme.palette.common.black}0D);
    }

    .Mui-disabled {
      & + .MuiSwitch-track {
        background-color: ${({ theme }) => theme.palette.background.default};
      }

      & .MuiSwitch-thumb {
        color: ${({ theme }) => theme.palette.stroke.primary};
        filter: none;
        border: none;
      }
    }
  }
`;
